import { Image } from "./Image";
import { OrderVariant } from "./OrderVariant";
import { Rule } from "./Rule";
import { State } from "./State";

export enum TriggeredRuleStatus {
  IN_VIOLATION = "in-violation",
  PRIOR_APPROVAL_PENDING = "prior-approval-pending",
  APPROVED = "approved",
  DENIED = "denied",
}

type TTriggeredRuleStatus = `${TriggeredRuleStatus}`;

export interface TriggeredRule {
  id: string;
  status: TTriggeredRuleStatus;
  note: null;
  mostRecentProgramName: string;
  itemTypeDescription: string;
  itemSpecification: any;
  itemRemoveFromCatalogDate: Date;
  itemQtyPerPack: number;
  itemId: string;
  itemNumber: string;
  itemEstimatedCost: string;
  itemComment: string;
  emailSentAt: null | Date;
  brandNames: string[];
  actionDate: null | Date;
  reviewedBy: null | string;
  approvalEmailSent: boolean;
  type: string;
  state: State;
  rule: Rule;
  item: null;
  orderVariant: OrderVariant;
  relationshipNames: string[];
  triggeredItemImages: Image[];
}

export type StrippedTriggeredRule = {
  status: TriggeredRuleStatus;
  ruleType: string;
  ruleDescription: string;
};
